<template>
  <div
    class="rank-header-item-container"
    @click="goToFocus()"
  >
    <van-image
      class="avatar-class"
      round
      width="50px"
      height="50px"
      fit="cover"
      :src="avatarurl"
    >
      <!-- this.article.bjhInfo.headUrl -->
    </van-image>
    <img
      v-if="this.rank === 1"
      class="border-img"
      src="../../../assets/bjnum-poprank-border-1.png"
      alt=""
    />
    <img
      v-if="this.rank === 1"
      class="rank-img"
      src="../../../assets/bjnum-poprank-1.png"
      alt=""
    />

    <img
      v-if="this.rank === 2"
      class="border-img"
      src="../../../assets/bjnum-poprank-border-2.png"
      alt=""
    />
    <img
      v-if="this.rank === 2"
      class="rank-img"
      src="../../../assets/bjnum-poprank-2.png"
      alt=""
    />

    <img
      v-if="this.rank === 3"
      class="border-img"
      src="../../../assets/bjnum-poprank-border-3.png"
      alt=""
    />
    <img
      v-if="this.rank === 3"
      class="rank-img"
      src="../../../assets/bjnum-poprank-3.png"
      alt=""
    />
    <span class="title-class">{{ this.bjhinfo.name }}</span>

    <span class="description-class">热度:{{ article?.heat }}</span>
  </div>
</template>

<script>
import { getBjhRankBjhinfo } from '@/api/article'

export default {
  name: 'RankHeaderItem',
  components: {},
  props: {
    article: {
      type: Object
      // required: true
    },
    rank: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      url: 'https://bjhh5.bjd.com.cn/master?column_id=',
      bjhinfo: {}
    }
  },
  computed: {
    avatarurl() {
      return this.bjhinfo?.avatar?.url
    }
  },
  watch: {
    article: function (newValue, oldValue) {
      // console.log(newValue.columnId)
      this.loadBjhInfo()
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    goToFocus() {
      // console.log('this.article', this.article)

      // window.location.href = this.url + this.article.columnId
      window.location = `https://mobile.bjd.com.cn/#/pages/bjh/special?info=1&uuid=${this.bjhinfo.uuid}&&isBang=1`
    },

    async loadBjhInfo() {
      console.log(this.article.columnId)
      const { data } = await getBjhRankBjhinfo({
        columnId: this.article.columnId
      })
      this.bjhinfo = data.data[this.article.columnId]
    }
  }
}
</script>

<style lang="less" scoped>
.rank-header-item-container {
  width: 125px;
  height: 150px;

  // display: flex;
  // align-content: center;
  // text-align: center;
  .avatar-class {
    display: block;
    position: absolute;
    width: 50px !important;
    height: 50px !important;
    left: 37.5px;
    top: 22px;
  }

  .rank-img {
    display: block;
    position: absolute;
    width: 23px;
    height: 14px;
    top: 11.5px;
    left: 51px;
  }

  .border-img {
    display: block;
    position: absolute;
    width: 81px;
    height: 80px;
    top: 10px;
    left: 22px;
  }

  .title-class {
    position: absolute;
    top: 90px;
    width: 115px;
    left: 5px;
    color: #fffecf;
    font-size: 11px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 15px;
    max-height: 35px;
    text-align: center;
  }

  .description-class {
    position: absolute;
    top: 110px;
    width: 115px;
    left: 5px;
    color: white;
    font-size: 11px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 15px;
    max-height: 35px;
    text-align: center;
  }
}
</style>
